module.exports = __webpack_public_path__ + "img/FR18569.128a857f.png";